import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.5491 1.28312C7.73016 0.905626 8.26968 0.905627 8.45074 1.28312L10.0849 4.69028C10.1578 4.84223 10.3029 4.94716 10.4705 4.96914L14.2316 5.46239C14.6484 5.51705 14.8152 6.02874 14.5102 6.31684L11.7595 8.91462C11.6367 9.03062 11.5812 9.20066 11.612 9.36642L12.3027 13.0772C12.3793 13.4886 11.9427 13.8048 11.5733 13.6053L8.23804 11.8044C8.0895 11.7242 7.91033 11.7242 7.7618 11.8044L4.42653 13.6053C4.05714 13.8048 3.62057 13.4886 3.69716 13.0772L4.38781 9.36642C4.41866 9.20066 4.36315 9.03062 4.24033 8.91462L1.48967 6.31684C1.18461 6.02874 1.35142 5.51705 1.76822 5.46239L5.52933 4.96914C5.69696 4.94716 5.84205 4.84223 5.91493 4.69028L7.5491 1.28312Z",
      stroke: "#8E8E93",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }